import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm, md },
} = constants.breakpoints;
const { fontSize } = typographyStyles;

const { ui } = constants.colors;
const neutral500 = ui.neutral[500];
const neutral700 = ui.neutral[700];
const neutral600 = ui.neutral[600];
const neutral100 = ui.neutral[100];

export const headerContainerCss = {
  padding: "0px",
  width: "100%",
  display: "flex",
  flexDirection: "column-reverse",
  gap: "48px",
  [mq.downTo(md)]: {
    flexDirection: "row",
  },
};

export const headerContentInfoCss = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export const headerContentTop = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
};

export const smallAddButton = {};

export const bigAddButton = {
  width: "45%",
  height: "30%",
  display: "flex",
};

export const linkWrapper = {
  width: "100%",
  display: "flex",
  justifyContent: "end",
  padding: "16px",
};

export const breadcrumbCss = {
  "li:nth-of-type(3)": {
    color: neutral700,
  },
};

export const challengesInfoSectionCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  height: "60px",
  marginTop: "48px",

  span: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "31.92px",
    fontWeight: "700",
    color: neutral700,
    ...fontSize.heading3,

    h6: {
      textTransform: "uppercase",
      margin: "4px 0 0",
      lineHeight: "15.96px",
      fontWeight: "400",
      color: neutral700,
      ...fontSize.textXS,
    },
  },

  [mq.downTo(md)]: {
    width: "55%",
  },
};

export const subheadingWrapper = {
  display: "flex",
  justifyContent: "space-between",
};

export const subheadingCss = {
  ...fontSize.textS,
  color: neutral500,
  textTransform: "uppercase",
};

export const descriptionWrapper = {
  display: "flex",
};

export const descriptionCss = {
  marginTop: "8px",
  width: "100%",
  marginBottom: "24px",
  color: neutral600,
  maxWidth: "800px",
};

export const headingCss = {
  fontFamily: "Circular",
  margin: "0px",
  lineHeight: "2.0rem",
  fontSize: "24px",
  [mq.downTo(xs)]: {
    lineHeight: "2.5rem",
    fontSize: "32px",
  },
};

export const headingImageCss = {
  height: "360px",
  borderRadius: "16px",
  width: "100%",
  [mq.downTo(md)]: {
    margin: "0 0 0 40px",
    width: "30%",
  },
};

export const possibleTokensContentCss = {
  display: "flex",
  alignItems: "center",
  width: "90%",
  border: `1px solid ${neutral100}`,
  margin: "8px",
  padding: "6px 10px",
  gap: "8px",
  borderRadius: "8px",

  [mq.downTo(sm)]: {
    width: "30%",
  },
};

export const progressBarContainerCss = {
  display: "flex",
  width: "100%",
  marginTop: "auto",
};

export const topicRowCss = {
  margin: "24px 0 20px",
  width: "90%",

  [mq.downTo(md)]: {
    width: "50%",
  },
};
